import styled from 'styled-components';

const StyledNumberOfBids = styled.div`
  white-space: nowrap;
  ${({ isPending }) => (isPending ? 'width: 50% ' : 'margin-right: 18px;')};
`;

export default StyledNumberOfBids;
